import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setWechatTitle } from '../utils/wechatTitle';
import { Image, Divider, Button, Grid, ImageViewer } from 'antd-mobile';
import FloatBackButton from '../components/FloatBackButton';
import RichTextDisplay from '../components/RichTextDisplay';
import BottomTabBar from './BottomTabBar';
import { useWechatShare, updateWxShareData } from '../utils/wechatShare';
import { navigateToLocation } from '../utils/navigation';
import { BusinessModel } from '../models/businessModel';

const DetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const imageViewerMultiRef = useRef(null);
  const [detail, setDetail] = useState(null);
  const [mainImageViewVisible, setMainImageViewVisible] = useState(false);
  const [moreImageViewVisible, setMoreImageViewVisible] = useState(false);
  const [error, setError] = useState('');
  
  
  const getDetail = useCallback(async () => {
    const pathParts = location.pathname.split('/');
    const id = pathParts[2]; // 商户ID
    if (id) {
      try {
        const data = await BusinessModel.getDetail({id});
        console.log('-----data-----', data);
        setDetail(data?.result);
        setWechatTitle(data.name);
      } catch (err) {
        console.error('商户数据加载失败', err);
        const errMsg = '加载数据失败，请重试';
        setError(errMsg);
        // Toast.show({ content: errMsg, type: 'fail' });
      } finally {
      }
    }
  }, [location.pathname]);

  // 从URL解析商户信息并设置标题
  useEffect(() => {
    getDetail();
  }, [getDetail]);
  
  // 微信分享配置
  const { wx, configured } = useWechatShare(
    detail?.name || '',
    detail?.description || '',
    detail?.mainImageUrl || '',
    window.location.href
  );

  // 更新分享配置
  useEffect(() => {
    if (detail && configured && wx) {
      console.log(JSON.stringify({
        title: detail.name,
        desc: detail.description,
        imgUrl: detail.mainImageUrl,
        link: window.location.href
      }, null, 2));
      updateWxShareData(wx,{
        title: detail.name,
        desc: detail.description,
        imgUrl: detail.mainImageUrl,
        link: window.location.href
      });
    }
  }, [detail, configured, wx]);

  // 导航按钮点击事件：直接传递最新的wx和configured
  const handleNavigate = useCallback(() => {
    // 添加安全检查，确保detail存在且包含必要的属性
    if (detail && detail.latitude && detail.longitude) {
      navigateToLocation(
        detail.latitude,
        detail.longitude,
        detail.name,
        detail.address,
        wx,
        configured
      );
    } else {
      console.warn('无法导航：缺少位置信息');
      // 可以在这里添加一个提示，告诉用户无法导航
    }
  }, [detail, wx, configured]); // 修改依赖数组，只依赖detail对象本身

  const handleCategoryChange = useCallback((category) => {
    navigate('/list?category='+category)
  }, [navigate]);

  // 更多图片的点击事件：显示图片预览器
  const handleImageClick = useCallback((index) => {
    setMoreImageViewVisible(true);
    if (imageViewerMultiRef.current) {
      imageViewerMultiRef.current.swipeTo(index);
    }
  }, []);

  // 点击拨号的回调（可选：可添加额外逻辑，如统计点击次数）
  const handleCall = useCallback(() => {
    window.location.href = `tel:${detail.contactPhone}`; // 核心：触发 tel: 协议
  }, [detail]);


  
  // 加载中状态
  if (!detail) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>加载中...</p>
      </div>
    );
  }
  
  if (error && !detail) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-red-500">
        <p>{error}</p>
        <button
          // onClick={() => fetchDetailes(1, true)}
          className="mt-2 px-4 py-2 bg-blue-600 text-white rounded"
        >
          重试
        </button>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* <Header title={detail.name} /> */}
      <FloatBackButton flex  onClick={() => navigate('/list?category='+detail.categoryId)} />
      <div style={{paddingBottom: 70}}>
        {/* 主图 */}
        <div className="w-full flex justify-center py-3 ">
          <Image 
            src={detail.mainImageUrl || '/images/default_main_img.jpg'}
            alt={detail.name}
            width={300}
            height={300}
            fit='cover'
            style={{ borderRadius: '1rem' }}
            onClick={() => {setMainImageViewVisible(true) }}
          />
          <ImageViewer
            classNames={{
              mask: 'customize-mask',
              body: 'customize-body',
            }}
            image={detail.mainImageUrl || '/images/default_main_img.jpg'}
            visible={mainImageViewVisible}
            onClose={() => {
              setMainImageViewVisible(false)
            }}
          />
        </div>
        
        {/* 名称/联系方式/地址 */}
        <div className="px-4 border-b- border-gray-300-">
          <div className="py-1">
            <h1>{detail.name}</h1>
          </div>
          <div className="py-1" style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
            <img src="/images/phone.png" style={{ width: 20, height: 20, objectFit: 'cover' }} />
            <span className="px-2 py-1" style={{ fontSize: 16, paddingLeft: 5,}}>
              <span>联系方式：</span>
              <Button
                type="primary"
                size="small"
                onClick={handleCall}
                style={{ width: 'auto', paddingHorizontal: 12, background: 'none', padding: 0, fontSize: 16, }} // 自定义样式（宽度自适应）
              >
                {detail.contactPhone}
              </Button>
            </span>
          </div>
          <div className="py-1" style={{ display: 'flex', alignItems: 'center', gap: 5, }} onClick={handleNavigate}>
            <img src="/images/dingwei.png" style={{ width: 20, height:20, objectFit: 'cover'}} />
            <span className="px-2 py-1" style={{ fontSize: 16, paddingLeft: 5,}}>
              地址：{detail.address}
            </span>
          </div>
        </div>
        
        <Divider style={{ borderColor: '#ded8d8'}} />
        
        {/* 简介和风险告知 */}
        <div className="px-4 ">
          <RichTextDisplay htmlContent={detail.richTextIntro} />
          <div style={{fontSize: 10, color: '#D9001B', paddingTop: 10}}>
            {detail.riskContentId ? '风险告知：' + detail.riskContentContent : ''}
          </div>
        </div>
        
        <Divider style={{ borderColor: '#ded8d8'}} />
        
        {/* 更多图片 */}
        <div className="px-4 more-images">
          <div className="font-semibold py-b-3" style={{fontSize: 18}}>更多图片</div>
          <Grid columns={3} gap={12}>
            {detail?.moreImageUrls?.split(',')?.filter(img => img)?.map((img, index) => (
              <Grid.Item key={index}>
                <Image 
                  src={img} 
                  alt={`${detail.name}图片 ${index + 1}`}
                  fit='cover'
                  style={{ borderRadius: '1rem' }}
                  onClick={() => {handleImageClick(index) }}
                />
              </Grid.Item>
            ))}
          </Grid>
          <ImageViewer.Multi
            ref={imageViewerMultiRef}
            images={detail.moreImageUrls?.split(',')?.filter(img => img) || []}
            visible={moreImageViewVisible}
            defaultIndex={0}
            onClose={() => {
              setMoreImageViewVisible(false)
            }}
          />
        </div>
      </div>
      
      {/* 底部固定 Tabs */}
      <BottomTabBar activeCategory={detail.categoryId} onTabChange={handleCategoryChange} />
    </div>
  );
};

export default DetailPage;